import { useRecordContext } from "react-admin";
import { Link as MUILink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const ClaimCountField = () => {
  const record = useRecordContext();

  if (!record) return null;

  const claimsCount = record.stoploss_claim_count ?? 0;

  if (claimsCount === 0) {
    return <span style={{ display: "block", fontVariantNumeric: "tabular-nums" }}>0</span>;
  }

  const claimantId = String(record.id);
  const to = `/stoploss-claims?${new URLSearchParams({
    filter: JSON.stringify({ claimant_id_ref: claimantId }),
  }).toString()}`;

  return (
    <MUILink
      component={RouterLink}
      to={to}
      underline="always"
      onClick={(e) => e.stopPropagation()}
      sx={{ display: "block", fontVariantNumeric: "tabular-nums" }}
    >
      {claimsCount.toLocaleString("en-US")}
    </MUILink>
  );
};
